export const SweepByLabel = {
  saleVolume: "Top CRO Sell Volume",
  buyVolume: "Top CRO Buy Volume",
  numberOfListings: "Top Listing",
  numberOfPurchases: "Top NFT Buy Count",
  numberOfSales: "Top NFT Sell Count",
};
